export default __webpack_public_path__ + "static/media/slide4.fbde62c8.jpg";